import FlexRow from "../../../../components/base/FlexRow";
import Icon from "../../../../components/base/Icon";
import { canManageJobs, createJob } from "../../../../core/Global";


// The board's Create Job button. (The view switcher, Find and Customize Board live in JobsFilterBar.)
export default function JobsBoardActions() {

    return (
        <FlexRow>
            {
                canManageJobs() &&
                <button className="btn btn-success btn-sm"
                    // Wider than a plain small button: the board's one main action.
                    style={{ paddingLeft: 42, paddingRight: 42 }}
                    onClick={e => {
                        e.preventDefault()
                        createJob()
                    }}>
                    <Icon icon="plus" />
                    <span>Create Job</span>
                </button>
            }
        </FlexRow>
    )
}
